import { Plus } from "lucide-react";
import { UserMealFormIngredientCollapsibleRow } from "./UserMealFormIngredientCollapsibleRow";

export function UserMealFormIngredients({
  form,
  updateIngredient,
  addIngredient,
  removeIngredient,
  ingredientUnits,
}) {
  return (
    <div>
      <div className="flex items-center justify-between mb-3">
        <p className="text-xs text-gray-500">
          {form.ingredients.length === 1
            ? "1 ingredient"
            : `${form.ingredients.length} ingredients`}
        </p>
        <button
          type="button"
          onClick={addIngredient}
          className="flex items-center gap-1.5 px-3 py-1.5 text-sm font-medium text-gray-700 hover:bg-gray-100 rounded-lg transition-colors"
        >
          <Plus className="w-4 h-4" />
          Add
        </button>
      </div>

      <div className="space-y-2">
        {form.ingredients.map((ingredient) => (
          <UserMealFormIngredientCollapsibleRow
            key={ingredient.id}
            ingredient={ingredient}
            updateIngredient={updateIngredient}
            removeIngredient={removeIngredient}
            showDeleteButton={form.ingredients.length > 1}
            ingredientUnits={ingredientUnits}
          />
        ))}
      </div>
    </div>
  );
}
